import { IContextualMenuItem } from "@fluentui/react";

export enum IFeatureRequestReducerType {
  LoadMenuItems,
  UpdateSelectedMenuItems
}

export interface IFeatureRequestFilterPillDispatchProps {
  type: IFeatureRequestReducerType;
  data: IContextualMenuItem[] | string[];
}